<ngx-mat-select-search [(ngModel)]="filter" [placeholderLabel]="searchPlaceholder">
  <div class="mat-select-search-custom-header-content">
    <svg-icon key="search" fontSize="16px"></svg-icon>
  </div>
  <span ngxMatSelectSearchClear>
    <svg-icon key="close" fontSize="16px"></svg-icon>
  </span>
</ngx-mat-select-search>
